import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Tooltip } from '@dojo/widgets/tooltip';
import { Keys } from '@holmescorp/common';
import { Icon } from '@holmescorp/base-widgets';
import { createNlsMiddleware, userstate } from '@holmescorp/lcc-state';
import css from '../../css/motivation.m.css';
import { Card } from '../../widgets';
const icache = createICacheMiddleware();
const ditabookNls = createNlsMiddleware('ditabook');
const factory = create({
    theme,
    icache,
    ditabookNls,
    userstate
}).properties();
export const MotivationCard = factory(({ id, properties, middleware: { theme, icache, ditabookNls } }) => {
    const themeCss = theme.classes(css);
    const { is_milestone = false, action } = properties();
    const { messages: { motivation_cards = '[]', milestone_cards = '[]' } } = ditabookNls();
    let xqa = 'card-motivation';
    let card_list = [];
    if (is_milestone) {
        xqa = 'card-milestone';
        try {
            card_list = JSON.parse(milestone_cards);
        }
        catch (e) {
            console.warn(`json parse error ${e}`, milestone_cards);
        }
    }
    else {
        try {
            card_list = JSON.parse(motivation_cards);
        }
        catch (e) {
            console.warn(`json parse error ${e}`, motivation_cards);
        }
    }
    const randomCard = icache.getOrSet('random_card', card_list[Math.floor(Math.random() * card_list.length)]);
    const mediaSrc = randomCard.mediaSrc;
    const title = randomCard.title;
    return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
        w(Card, {
            xqa
        }, [
            {
                content: v('div', {
                    classes: [themeCss.content],
                    styles: {
                        backgroundImage: `url(${mediaSrc})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }
                }, [
                    v('div', {
                        classes: [themeCss.demote],
                        xqa: `${xqa}-action`,
                        role: 'button',
                        tabIndex: 0,
                        ...formatAriaProperties({ label: 'Close' }),
                        onmouseover: () => icache.set('demote_ttopen', true),
                        onmouseout: () => icache.set('demote_ttopen', false),
                        onfocus: () => icache.set('demote_ttopen', true),
                        onblur: () => icache.set('demote_ttopen', false),
                        onclick: () => {
                            action();
                        },
                        onkeydown: (event) => {
                            switch (event.key) {
                                case Keys.Enter:
                                case Keys.Space:
                                case Keys.Spacebar:
                                    event.preventDefault();
                                    action();
                                    break;
                            }
                        }
                    }, [
                        w(Tooltip, {
                            open: icache.getOrSet('demote_ttopen', false),
                            orientation: 'top'
                        }, [
                            {
                                content: 'Close',
                                trigger: v('span', {
                                    ...formatAriaProperties({ hidden: 'true' }),
                                    xqa: `${xqa}-action-demote`
                                }, [
                                    w(Icon, {
                                        fapre: 'far',
                                        faname: 'square-minus'
                                    })
                                ])
                            }
                        ])
                    ]),
                    v('div', {}, []),
                    v('div', { classes: [themeCss.title] }, [title])
                ])
            }
        ])
    ]);
});
export default MotivationCard;
